import { render, staticRenderFns } from "./A10Info.vue?vue&type=template&id=345cd96e&"
import script from "./A10Info.vue?vue&type=script&lang=ts&"
export * from "./A10Info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports